import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/SidebarAdmin.css";
import axios from "axios";
import {FaHome,FaBell,FaBuilding,FaUserEdit,FaSignOutAlt,FaUser,FaBars,FaComments} from "react-icons/fa";
import ChatWidget from "./ChatWidget";
import { apiGet } from "../utils/api";

const SidebarAdmin = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [openChat, setOpenChat] = useState(false);
  const [companyQuery, setCompanyQuery] = useState("");
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [activities, setActivities] = useState([]);
  const [activityId, setActivityId] = useState("");
  const [audits, setAudits] = useState([]);
  const [auditId, setAuditId] = useState("");
  //FETCH ACTIVITIES & AUDITS
  useEffect(() => {
    apiGet("/activities")
      .then(r => r.json())
      .then(data => setActivities(Array.isArray(data) ? data : []));
    apiGet("/audits")
      .then(r => r.json())
      .then(data => setAudits(Array.isArray(data) ? data : []));
  }, []);

  //SEARCH BY COMPANY NAME
  useEffect(() => {
    if (companyQuery.length < 2) {
      setCompanies([]);
      return;
    }
  const timeout = setTimeout(() => {
    apiGet(`/companies?name=${companyQuery}`)
      .then(r => r.json())
      .then(data => setCompanies(Array.isArray(data) ? data : []))
      .catch(() => setCompanies([]));
  }, 400);

  return () => clearTimeout(timeout);
  }, [companyQuery]);

  // FILTER BY ACTIVITY
  useEffect(() => {
    if (!activityId) return;
    apiGet(`/companies?activity_id=${activityId}`)
      .then(r => r.json())
      .then(data => setCompanies(Array.isArray(data) ? data : []));
    setCompanyQuery("");
    setAuditId("");
  }, [activityId]);

  // FILTER BY AUDIT
  useEffect(() => {
    if (!auditId) return;
    apiGet(`/companies?audit_id=${auditId}`)
      .then(r => r.json())
      .then(data => setCompanies(Array.isArray(data) ? data : []));
    setCompanyQuery("");
    setActivityId("");
  }, [auditId]);
  
  // UNREAD NOTIFICATIONS
  useEffect(() => {
    const fetchUnread = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          "https://alloaudit.com/api/notifications/user",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUnreadCount(res.data.filter(n => !n.is_read).length);
      } catch (e) {
        console.error(e);
      }
    };
    fetchUnread();
  }, []);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <>
      <button className="sidebar-toggle-btn" onClick={() => setOpen(!open)}>
        <FaBars />
      </button>
      <aside className={`sidebar-admin ${open ? "open" : ""}`}>
        <nav className="sidebar-nav">
          <NavLink to="/admin/dashboard" className="sidebar-link">
            <FaHome /> Dashboard
          </NavLink>
          <NavLink to="/admin/notifications" className="sidebar-link badge-wrapper">
            <FaBell /> Notifications
            {unreadCount > 0 && <span className="badge-notif">{unreadCount}</span>}
          </NavLink>
          <NavLink to="/admin/companies" className="sidebar-link">
            <FaBuilding /> Companies
          </NavLink>
          <NavLink to="/admin/customers" className="sidebar-link">
            <FaUser /> Customers
          </NavLink>
          <NavLink to="/admin/profile" className="sidebar-link">
            <FaUserEdit /> Update Profile
          </NavLink>
          <button onClick={handleLogout} className="sidebar-link logout-btn">
            <FaSignOutAlt /> Logout
          </button>
        </nav>
        <button onClick={() => setOpenChat(true)} className="sidebar-linkk">
          <FaComments /> Chat
        </button>
      </aside>
      {openChat && (
        <div className="admin-chat-modal">
          <input
            placeholder="Search company..."
            value={companyQuery}
            onChange={e => setCompanyQuery(e.target.value)}
          />
          <select value={activityId} onChange={e => setActivityId(e.target.value)}>
            <option value="">Select activity</option>
            {activities.map(a => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>
          <select value={auditId} onChange={e => setAuditId(e.target.value)}>
            <option value="">Select audit</option>
            {audits.map(a => (
              <option key={a.id} value={a.id}>{a.title}</option>
            ))}
          </select>
          <div className="dropdown">
            {companies.map(c => (
              <div
                key={c.id}
                className="dropdown-item"
                onClick={() => setCompanyId(c.id)}
              >
                {c.company_name}
              </div>
            ))}
          </div>
          {companyId && (
            <ChatWidget
              companyId={companyId}
              onClose={() => {
                setCompanyId(null);
                setOpenChat(false);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};
export default SidebarAdmin;
